import { render, staticRenderFns } from "./VideoBlockComponent.vue?vue&type=template&id=6367126c&scoped=true&"
import script from "./VideoBlockComponent.vue?vue&type=script&lang=js&"
export * from "./VideoBlockComponent.vue?vue&type=script&lang=js&"
import style0 from "./VideoBlockComponent.vue?vue&type=style&index=0&id=6367126c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6367126c",
  null
  
)

export default component.exports